<template>
    <div>
        <nav-bar v-if="!isBigMode"></nav-bar>
        <div class="container-box" v-if="$route.path=='/resourceLibrary'">
            <div class="top-box">
                <div style="width: 100%;display: flex;justify-content: center;">
                    <div class="input-box">
                        <i class="iconfont icon-Magnifier" @click="search"></i>
                        <i class="el-icon-circle-close" @click="clearSearch" :class="{'clear-active':keywords}"></i>
                        <input type="text" v-model="keywords" class="input-ipt" @keydown.enter="search" placeholder="请输入关键字">
                        <button class="search-button" @click="search">搜索</button>
                    </div>
                </div>
                <div class="second-box">
                    <div class="category-item" :class="{active:currentCategory==item.value}" v-for="(item,index) in catrgoryOptions" @click="changeCategory(item)" :key="index">{{ item.label }}</div>
                </div>
                <!-- <div class="third-box">
                    <div class="left">
                        <img style="width: 4.3rem;height: 3.3rem;" src="../assets/image/resourceLibrary/library.png" alt="">
                        <countTo style="width: 10rem;" :startVal="0" :endVal="typeSum" :duration="3000"></countTo>
                        <div>资源库</div>
                    </div>
                    <div class="right">
                        <div v-for="(item,index) in typeOptions"  @click="changeType(item)" class="right-item" :key="index">
                            <img style="width: 2.2rem;height: 2rem;" :src="item.img" alt="">
                            <p :class="{active:currentType==item.value}">{{ item.label }}</p>
                            <p :class="{active:currentType==item.value}">（{{ item.number }}）</p>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="third-box">
                    <div class="left">
                        <img style="width: 4.3rem;height: 3.3rem;" src="../assets/image/resourceLibrary/library.png" alt="">
                        <countTo style="width: 10rem;" :startVal="0" :endVal="typeSum" :duration="3000"></countTo>
                        <div>资源库</div>
                    </div>
                    <div class="right">
                        <div v-for="(item,index) in typeOptions"  @click="changeType(item)" class="right-item" :key="index">
                            <img style="width: 2.2rem;height: 2rem;" :src="item.img" alt="">
                            <p :class="{active:currentType==item.value}">{{ item.label }}</p>
                            <p :class="{active:currentType==item.value}">（{{ item.number }}）</p>
                        </div>
                    </div>
                </div>
            <div class="table-box">
                    <p class="title">热门资源 <el-tooltip class="item" effect="dark" content="按浏览量降序排列" placement="top-start">
                        <i class="iconfont icon-tishi" style="font-size: 2rem;"></i>
                    </el-tooltip> </p>
                    <resource-library class="animate__animated animate__fadeIn" :dataList="heartData" @view_detail="toDetail"></resource-library>
                    <p class="title" style="margin-top: 6rem;">资源列表<el-tooltip class="item" effect="dark" content=" 排序权重（点赞量、浏览量、收藏量）" placement="top-start">
                        <i class="iconfont icon-tishi" style="font-size: 2rem;margin-left: 0.5rem;"></i>
                    </el-tooltip></p>
                    <resource-library class="animate__animated animate__fadeIn" :dataList="tableData" @view_detail="toDetail"></resource-library>
                    <div class="pagination-box" v-if="pages.total>0">
                        <el-pagination
                        background
                        :page-size="pages.size"
                        :current-page="pages.current"
                        :pager-count="5"
                        :layout="$store.state.media.layout"
                        :page-sizes="[6, 12, 18, 24]"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :total="pages.total">
                        </el-pagination>
                    </div>
            </div>
            <bottom-slider></bottom-slider>
        </div>
        <router-view v-else></router-view>
    </div>
</template>

<script>
import ResourceLibrary from '@/components/resourceLibrary/ResourceList';
import { Category } from '@/utils/utils';
import { GetResDataCount,GetTopData,PageResourceList } from '@/api/ResourceLibrary';
import { ResourcePages } from '@/utils/page';
    export default {
        components:{ResourceLibrary},
        data(){
            return {
                keywords:'',
                currentCategory:'',
                currentType:'',
                catrgoryOptions:[
                    {
                        label:'全部',
                        value:''
                    },
                    ...Category
                ],
                typeOptions:[
                    {
                        label:'软件',
                        value:'仿真软件',
                        img:require('../assets/image/resourceLibrary/rj.png'),
                        number:0
                    },
                    {
                        label:'动画',
                        value:'动画',
                        img:require('../assets/image/resourceLibrary/dh.png'),
                        number:0
                    },
                    {
                        label:'模型',
                        value:'模型',
                        img:require('../assets/image/resourceLibrary/mx.png'),
                        number:0
                    },
                    {
                        label:'视频',
                        value:'视频',
                        img:require('../assets/image/resourceLibrary/sp.png'),
                        number:0
                    },
                    {
                        label:'课件',
                        value:'ppt',
                        img:require('../assets/image/resourceLibrary/kj.png'),
                        number:0
                    },
                    {
                        label:'图片',
                        value:'图片',
                        img:require('../assets/image/resourceLibrary/tp.png'),
                        number:0
                    },
                    {
                        label:'试卷',
                        value:'试卷',
                        img:require('../assets/image/resourceLibrary/sj.png'),
                        number:0
                    },
                    {
                        label:'文档',
                        value:'文档',
                        img:require('../assets/image/resourceLibrary/wd.png'),
                        number:0
                    },
                ],
                typeSum:0,
                tableData:[],
                heartData:[],
                pages:{
                    current:1,
                    size:6,
                    total:0
                }
            }
        },
        computed: {
            isBigMode() {
                return this.$store.state.menu.isBigMode;
            }
        },
        methods:{
            /**清空搜索 */
            clearSearch(){
                this.keywords='';
                this.search();
            },
            /**获取资源数量 */
            getResDataCount(){
                var params={
                "classifyCode":this.currentCategory,
                "resName":this.keywords,
                "resType": ''
                }
                GetResDataCount(params).then(res=>{
                    if(res.code==200){
                        var obj={};
                        let sum=0;
                        res.data.forEach(item=>{
                            obj[item.resType]=item.resCount;
                            sum=sum+item.resCount;
                        })
                        this.typeOptions.forEach(item=>{
                            item.number=obj[item.value]||0;
                        })
                        this.typeSum=sum;
                    }
                })
            },
            /**查询热门资源 */
            getTopData(){
                var params={
                "classifyCode": this.currentCategory,
                "resName":this.keywords,
                "resType": this.currentType,
                }
                GetTopData(params).then(res=>{
                    if(res.code==200){
                        this.heartData=res.data;
                    }
                })
            },
            /**分页查询资源 */
            pageResourceList(){
                var params={
                "classifyCode": this.currentCategory,
                "current": this.pages.current,
                "resName":this.keywords,
                "resType": this.currentType,
                "size": this.pages.size
                }
                PageResourceList(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**查看资源详情 */
            toDetail(data){
                ResourcePages.current=this.pages.current;
                ResourcePages.currentType=this.currentType;
                ResourcePages.keywords=this.keywords;
                if(data.resType=='仿真软件'){
                    this.$router.push({
                    path:'/personCenter/softwareDetail',
                    query:{id:data.id}
                })
                }else if(data.resType=='试卷'){
                    this.$router.push({
                    path:'/personCenter/paperDetail',
                    query:{
                        id:data.id,
                        testPaperSource:'test_paper_lib'
                    }
                })
                }else{
                    this.$router.push({
                        path:'/resourceLibrary/resourceDetail',
                        query:{id:data.id,type:data.resType}
                    })
                }
            },
            search(){
                this.pages.current=1;
                this.pageResourceList();
                this.getTopData();
                this.getResDataCount();
            },
            changeCategory(item){
                this.currentCategory=item.value;
                this.search();
            },
            changeType(item){
                if(this.currentType==item.value){
                    this.currentType='';
                }else{
                    this.currentType=item.value;
                }
                this.search();
            },
            handleSizeChange(val) {
                this.pages.size=val;
                this.search();
            },
            // 翻页
            handleCurrentChange(val) {
                this.pages.current=val;
                this.pageResourceList();
            },
        },
        beforeRouteLeave(to,form,next){
            ResourcePages.current=1;
            ResourcePages.currentType='';
            ResourcePages.keywords='';
            next();
        },
        mounted(){
            this.pages.current=ResourcePages.current;
            this.currentType=ResourcePages.currentType;
            this.keywords=ResourcePages.keywords;
            if(this.$route.path=='/resourceLibrary'){
                this.getResDataCount();
                this.getTopData();
                this.pageResourceList();
            }
        },
        watch:{
            $route(val){
                if(val.path=='/resourceLibrary'){
                    this.getResDataCount();
                    this.getTopData();
                    this.pageResourceList();
                }
            }
        },
    }
</script>

<style lang="less" scoped>
/deep/.el-pager>.active {
    background-color: #387dff !important;
}
.clear-active{
    opacity: 1 !important;
}
.top-box{
    padding: 0 var(--padding) 0 var(--padding);
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
    background-image: url('../assets/image/resourceLibrary/banner.png');
    background-size: 100% 100%;
    height: 41rem;
    margin-top: 8.5rem;
}
.input-box{
    margin-top: 8rem;
    position: relative;
    display: inline-flex;
    max-width: 100%;
    .icon-Magnifier{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 2rem;
        color: #BFC0C8;
        cursor: pointer;
        font-size: 2rem;
        z-index: 9;
    }
    .el-icon-circle-close{
        position: absolute;
        right: 11rem;
        top: 50%;
        font-size: 1.8rem;
        transform: translateY(-50%);
        color: #d7dae2;
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
        z-index: 9;
    }
    .el-icon-circle-close:hover{
        color: var(--blue);
    }
}
.input-ipt{
    width: 60rem;
    height: 4.5rem;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
    position: relative;
    flex-shrink: 1;
}

input::placeholder {
  font-size: 14px; /* 更改placeholder的字体大小 */
  position: absolute;
  left: 5rem;
}
.search-button{
    width: 10rem;
    height: 4.5rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    background-color: #3972FF;
    cursor: pointer;
    border: none;
    color: #ffffff;
    font-size: 14px;
    flex-shrink: 0;
}
.second-box{
    width: 100%;
    padding: 2rem 6rem;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 0px 11.96px 0px rgba(225,229,239,0.30); 
    margin-top: 5.6rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 1rem;
    column-gap: 6rem;
}
.third-box{
    width: calc(100% - 2*var(--padding));
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 0px 12px 0px rgba(225,229,239,0.30);
    padding: 3rem 6rem;
    align-items: center;
    display: flex;
    transform: translateX(var(--padding)) translateY(-10rem);
    .left{
        color: #3972FF;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 5rem;
        &> :nth-child(1){
            font-size: 3rem;
        }
        &> :nth-child(2){
            font-size: 3rem;
            font-weight: 700;
            margin: 1rem 0 1rem 0;
            display: block;
        }
    }
    .right{
        display: flex;
        height: 100%;
        font-size: 1.8rem;
        align-content: center;
        flex-wrap: wrap;
        row-gap: 3rem;
        i{
            color: #3972FF;
        }
        .right-item{
            display: flex;
            align-items: center;
            margin-left: 10rem;
            width: 15rem;
            cursor: pointer;
            &> :nth-child(2){
                margin-left: 1rem;
            }
            &> :nth-child(2),&> :nth-child(3){
                color: #3F3F3F;
            }
        }
    }
}
.category-item{
    color: #3F3F3F;
    font-size: 1.8rem;
    // margin-left: 6rem;
    cursor: pointer;
}
.active{
    color: #3972FF !important;
    font-weight: 700;
}
.table-box{
    padding: 0 var(--padding) 6rem var(--padding);
.title{
    font-weight: 700;
    color: #2B3036;
    font-size: 2.4rem;
    margin-bottom: 3rem;
}
}
.pagination-box{
    text-align: center;
    padding: 7rem 0 9rem 0;
}
input:focus {
  outline: none; /* 首先移除默认的轮廓样式 */
  border: 1px solid none; /* 设置焦点时的边框颜色 */
  transition: all 0.3s;
}
@media screen and (max-width:750px){
    .second-box{
        column-gap: 4rem !important;
        padding: 2rem 4rem;
    }
    .top-box{
        background-size: auto !important;
    }
}
</style>